export default class Locale_SettingsBackup { 
	ConfirmRestorationToBackupSettings: string = "Are you sure you want to restore this settings backup? This cannot be undone!!";
	SettingsRestored: string = "Settings restored";
	PleaseRefreshPage: string = "Please refresh the page, to ensure all settings are correctly loaded";
	ChangedProperties: string = "Changed Properties";
	RestoreSelectedBackup: string = "Restore selected backup";
}